import React from 'react';

import ModuleContainer from '../components/ModuleContainer';
import Link from '../components/Link';

import './Linking.scss';

const LinkingTitle = ({ hasMainTitle, title }) =>
  hasMainTitle ? (
    <h3 className="linking-subtitle">{title}</h3>
  ) : (
    <h2 className="linking-title">{title}</h2>
  );

const LinkingSection = ({ links, hasMainTitle, title }) => (
  <section className="linking-section">
    {title && <LinkingTitle title={title} hasMainTitle={hasMainTitle} />}
    <div className="linking-container">
      {links.map(({ url, anchorText }) => (
        <Link key={url} href={url}>
          {anchorText}
        </Link>
      ))}
    </div>
  </section>
);

const Linking = ({ highlighted, title, linkingSections = [] }) =>
  !!linkingSections.length && (
    <ModuleContainer highlighted={highlighted}>
      {title && <h2 className="linking-title">{title}</h2>}
      {linkingSections.map((section, i) => (
        <LinkingSection {...section} key={i} hasMainTitle={title} />
      ))}
    </ModuleContainer>
  );

export default Linking;
